<template>
  <section>
    <div class="info-header mt-2">
      <slot></slot
      ><b-button
        v-if="showAddRemove"
        @click="showAdd"
        size="sm"
        class="ml-2 no-border"
        ><i class="fal fa-plus"></i> {{ $t("ADD") }}</b-button
      >
    </div>

    <SDKPersonId
      show-add-remove
      :items="items"
      @removeItem="removeItem"
    ></SDKPersonId>

    <b-modal
      v-model="show"
      hide-header-close
      @cancel="cancelSave"
      @ok="okSave"
      :ok-disabled="okDisabled"
      :dialog-class="teams.theme"
      :title="extensionCaption"
      centered
      :cancel-title="$t('CANCEL')"
      :ok-title="$t('ADD')"
    >
      <b-form-group id="input-1" :label="labelCaption" label-for="input-2">
        <b-form-input trim
          v-model="label"
          aria-describedby="label-help-block"
          placeholder=""
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-2" :label="rootCaption" label-for="input-2">
        <b-form-select
          v-model="root"
          :options="options"
        ></b-form-select>
      </b-form-group>

      <b-form-group id="input-3" label-for="input-2" v-if="root != ''">

        <b-form-input trim v-if="showRegular" :state="showValid" v-model="extension" aria-describedby="extension-help-block"></b-form-input>
         <Pnr required v-model="extension" @valid="setValid" v-if="root == '1.2.752.129.2.1.3.1'"></Pnr>
                  
         <Email v-model="extension" @valid="setValid"  v-if="root == '0.9.2342.19200300.100.1.3'"></Email>

        <b-form-text id="extension-help-block">{{
          extensionDescription
        }}</b-form-text>
      </b-form-group>

    </b-modal>
  </section>
</template>
<script>
import Pnr from "../../Input/Pnr.vue";
import Email from "../../Input/Email.vue";
import SDKPersonId from "../../View/Information/Metadata/SdkPersonId";
export default {
  components: {
    SDKPersonId,Pnr,Email
  },
  props: {
    value: {
      type: Array,
      Default: [],
    },
    isSender: {
      type: Boolean,
      validator(value) {
        return value != undefined;
      },
    },
    showAddRemove: {
      type: Boolean,
      validator(value) {
        return value != undefined;
      },
    },
  },
  data() {
    return {
      show: false,
      items: this.value,
      label: "",
      extension: "",
      root: "",
      options: [],
      valid: false
    };
  },
  methods: {
    setValid(valid)
    {
      this.valid = valid;
    },  
    showAdd() {
      this.show = true;
    },
    getExtentionName(item) {
      let filtered = this.options.filter(
        (c) => c.value == item.personId.extension
      );
      return filtered[0].text;
    },
    cancelSave() {
      this.clearAdd();
      this.show = false;
    },
    clearAdd() {
      this.root = "";
      this.extension = "";
      this.label = "";
    },
    okSave() {
      this.items.push({
        label: this.label,
        personId: {
          extension: this.extension,
          root: this.root,
        },
      });
      this.$emit("input", this.items);
      this.show = false;
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.$emit("input", this.items);
    }
  },
  computed: {
    showValid(){
      if(this.root == "")
      {
        return null;
      }
      if(this.showRegular && this.extension != "")
      {
        return true;
      }
      return false;
    },
    okDisabled() {
      if(this.root == ""){
        return true;
      }
      if(this.label == "")
      {
        return true;
      }
      if(this.extension == "")
      {
        return true;
      }
      if(!this.showRegular)
      {
        return !this.valid;
      }
      return false;
    },
    labelCaption() {
      return this.$t("SDK.PERSONID.LABEL.TITLE");
    },
    extensionCaption() {
      if (this.isSender) {
        return this.$t("SDK.PERSONID.EXTENSION.SENDER.TITLE");
      }
      return this.$t("SDK.PERSONID.EXTENSION.RECIPIENT.TITLE");
    },
    extensionDescription() {
      if (this.isSender) {
        return this.$t("SDK.PERSONID.EXTENSION.SENDER.SMALL");
      }
      return this.$t("SDK.PERSONID.EXTENSION.RECIPIENT.SMALL");
    },
    rootCaption() {
      return this.$t("SDK.PERSONID.ROOT.TITLE");
    },
    rootDescription() {
      return this.$t("SDK.PERSONID.ROOT.SMALL");
    },
    showRegular(){
      if(this.root == "1.2.752.129.2.1.3.1")
      {
        return false;
      }
      if(this.root == "0.9.2342.19200300.100.1.3")
      {
        return false;
      }
      return true;      
    }
  },
  watch: {},
  mounted() {
    this.options.push({ value: "", text: this.$t("CHOOSE") });
    this.options.push({
      value: "1.2.752.129.2.1.3.1",
      text: this.$t("SDK.ITEMS.1_2_752_129_2_1_3_1"),
    });
    this.options.push({
      value: "1.2.752.29.6.2.1",
      text: this.$t("SDK.ITEMS.1_2_752_29_6_2_1"),
    });
    this.options.push({
      value: "0.9.2342.19200300.100.1.3",
      text: this.$t("SDK.ITEMS.0_9_2342_19200300_100_1_3"),
    });
    this.options.push({
      value: "1.2.752.129.2.1.2.1",
      text: this.$t("SDK.ITEMS.1_2_752_129_2_1_2_1"),
    });
  },
};
</script>
<style></style>
